// extracted by mini-css-extract-plugin
export default {"video_card":"VideoCard_video_card__XqSSG","overlay":"VideoCard_overlay__fEJGe","hover":"VideoCard_hover__krRzN","overlay2":"VideoCard_overlay2__Qjih-"};